import { render, staticRenderFns } from "./ColorDialog.vue?vue&type=template&id=0760df33&scoped=true"
import script from "./ColorDialog.vue?vue&type=script&lang=js"
export * from "./ColorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760df33",
  null
  
)

export default component.exports